function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/arrayWithoutHoles.js
 ** module id = 692
 ** module chunks = 0
 **/